// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Razorpay payment tab inside Admin Panel
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
// const RZP_KEY =
//   process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_test_SkA20iW9nwTXMH";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);

//   // ✅ Get hospitalId from JWT
//   const getHospitalId = () => {
//     try {
//       const path = window.location.pathname;
//       const match = path.match(/\/hospital\/([^/]+)/);
//       const slug = match ? match[1] : null;
//       const key = slug
//         ? `pearlsmile_token_${slug}`
//         : "pearlsmile_token_pearlsmile";
//       const token = localStorage.getItem(key);
//       if (!token) return null;
//       const payload = JSON.parse(atob(token.split(".")[1]));
//       return payload?.hospitalId || null;
//     } catch {
//       return null;
//     }
//   };

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }

//     setPaying(true);
//     try {
//       const res = await fetch(`${BASE}/razorpay/create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId, plan: plan.id }),
//       });
//       const order = await res.json();
//       if (!res.ok) throw new Error(order.message);

//       const options = {
//         key: RZP_KEY,
//         amount: order.amount,
//         currency: order.currency,
//         name: "VidyaOne",
//         description: order.planLabel,
//         order_id: order.orderId,
//         prefill: {
//           name: order.hospitalName,
//           email: order.hospitalEmail || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           try {
//             const verifyRes = await fetch(`${BASE}/razorpay/verify-payment`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//                 hospitalId,
//                 plan: plan.id,
//               }),
//             });
//             const verifyData = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(verifyData.message);

//             showNotify(
//               "✅ Payment Successful!",
//               `Your ${plan.name} plan is now active. Confirmation email sent!`,
//             );
//             // Refresh status
//             const statusRes = await fetch(
//               `${BASE}/razorpay/status/${hospitalId}`,
//             );
//             setStatus(await statusRes.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//       setPaying(false);
//     }
//     setPaying(false);
//   };

//   if (!hospitalId) {
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your VidyaOne subscription plan.
//       </div>

//       {/* Current Status */}
//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 marginBottom: 8,
//                 flexWrap: "wrap",
//               }}
//             >
//               <span style={{ fontSize: 18 }}>
//                 {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//               </span>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//                 {status.isActive
//                   ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
//                   : status.daysLeft > 0
//                     ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                     : "Trial Expired"}
//               </div>
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Renews" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       {/* Plans */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period}
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : plan.featured
//                       ? `linear-gradient(135deg,${plan.color},#b8960a)`
//                       : `linear-gradient(135deg,#0d7377,#14a0a5)`,
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor: paying ? "not-allowed" : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>

//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · EMI available · GST applicable
//       </div>
//     </div>
//   );
// }

///////////// above is correct /////////
// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Fixed getHospitalId — reads all localStorage tokens
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
// const RZP_KEY =
//   process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_test_SkA20iW9nwTXMH";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// // ✅ Fixed — scans all localStorage keys for pearlsmile tokens
// function getHospitalId() {
//   try {
//     // First try URL-based approach
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;

//     if (slug) {
//       const key = `pearlsmile_token_${slug}`;
//       const token = localStorage.getItem(key);
//       if (token) {
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }

//     // Fallback — scan all localStorage keys for any pearlsmile token
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         try {
//           const token = localStorage.getItem(key);
//           const payload = JSON.parse(atob(token.split(".")[1]));
//           if (payload?.hospitalId) return payload.hospitalId;
//         } catch (_) {}
//       }
//     }
//     return null;
//   } catch {
//     return null;
//   }
// }

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const hId = getHospitalId();
//     if (!hId) {
//       showNotify("Error", "Not logged in. Please login first.", true);
//       return;
//     }

//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }

//     setPaying(true);
//     try {
//       const res = await fetch(`${BASE}/razorpay/create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
//       });
//       const order = await res.json();
//       if (!res.ok) throw new Error(order.message);

//       const options = {
//         key: RZP_KEY,
//         amount: order.amount,
//         currency: order.currency,
//         name: "VidyaOne",
//         description: order.planLabel,
//         order_id: order.orderId,
//         prefill: {
//           name: order.hospitalName,
//           email: order.hospitalEmail || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           try {
//             const verifyRes = await fetch(`${BASE}/razorpay/verify-payment`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//                 hospitalId: hId,
//                 plan: plan.id,
//               }),
//             });
//             const data = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(data.message);
//             showNotify(
//               "✅ Payment Successful!",
//               `Your ${plan.name} plan is now active! Confirmation email sent.`,
//             );
//             const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//             setStatus(await s.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setPaying(false);
//   };

//   if (!hospitalId) {
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your VidyaOne subscription plan.
//       </div>

//       {/* Current Status */}
//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 marginBottom: 8,
//                 flexWrap: "wrap",
//               }}
//             >
//               <span style={{ fontSize: 18 }}>
//                 {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//               </span>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//                 {status.isActive
//                   ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
//                   : status.daysLeft > 0
//                     ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                     : "Trial Expired"}
//               </div>
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Renews" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       {/* Plans */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period}
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : `linear-gradient(135deg,#0d7377,#14a0a5)`,
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor:
//                   paying || (status?.isActive && status?.plan === plan.id)
//                     ? "not-allowed"
//                     : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>

//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · EMI available · GST applicable
//       </div>
//     </div>
//   );
// }

// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Fixed: uses order.keyId from backend + updated fallback key
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// // ✅ Scans all localStorage keys for pearlsmile tokens
// function getHospitalId() {
//   try {
//     // First try URL-based approach
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;

//     if (slug) {
//       const key = `pearlsmile_token_${slug}`;
//       const token = localStorage.getItem(key);
//       if (token) {
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }

//     // Fallback — scan all localStorage keys for any pearlsmile token
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         try {
//           const token = localStorage.getItem(key);
//           const payload = JSON.parse(atob(token.split(".")[1]));
//           if (payload?.hospitalId) return payload.hospitalId;
//         } catch (_) {}
//       }
//     }
//     return null;
//   } catch {
//     return null;
//   }
// }

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const hId = getHospitalId();
//     if (!hId) {
//       showNotify("Error", "Not logged in. Please login first.", true);
//       return;
//     }

//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }

//     setPaying(true);
//     try {
//       const res = await fetch(`${BASE}/razorpay/create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
//       });
//       const order = await res.json();
//       if (!res.ok) throw new Error(order.message);

//       const options = {
//         key: order.keyId, // ✅ use key from backend response
//         amount: order.amount,
//         currency: order.currency,
//         name: "VidyaOne",
//         description: order.planLabel,
//         order_id: order.orderId,
//         prefill: {
//           name: order.hospitalName,
//           email: order.hospitalEmail || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           try {
//             const verifyRes = await fetch(`${BASE}/razorpay/verify-payment`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//                 hospitalId: hId,
//                 plan: plan.id,
//               }),
//             });
//             const data = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(data.message);

//             showNotify(
//               "✅ Payment Successful!",
//               `Your ${plan.name} plan is now active! Confirmation email sent.`,
//             );
//             // ✅ Refresh subscription status after payment
//             const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//             setStatus(await s.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setPaying(false);
//   };

//   if (!hospitalId) {
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your VidyaOne subscription plan.
//       </div>

//       {/* ── Current Status Banner ───────────────────────────── */}
//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${
//                 status.isActive
//                   ? "#bbf7d0"
//                   : status.daysLeft < 3
//                     ? "#fecaca"
//                     : "#fde68a"
//               }`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 marginBottom: 8,
//                 flexWrap: "wrap",
//               }}
//             >
//               <span style={{ fontSize: 18 }}>
//                 {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//               </span>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//                 {status.isActive
//                   ? `${
//                       status.plan?.charAt(0).toUpperCase() +
//                       status.plan?.slice(1)
//                     } Plan — Active`
//                   : status.daysLeft > 0
//                     ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                     : "Trial Expired"}
//               </div>
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Renews" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       {/* ── Plans Grid ─────────────────────────────────────── */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period}
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : `linear-gradient(135deg,#0d7377,#14a0a5)`,
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor:
//                   paying || (status?.isActive && status?.plan === plan.id)
//                     ? "not-allowed"
//                     : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>

//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · EMI available · GST applicable
//       </div>
//     </div>
//   );
// }

// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Rebranded: PranJeev → PranJeev
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// function getHospitalId() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     if (slug) {
//       const token = localStorage.getItem(`pearlsmile_token_${slug}`);
//       if (token) {
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         try {
//           const token = localStorage.getItem(key);
//           const payload = JSON.parse(atob(token.split(".")[1]));
//           if (payload?.hospitalId) return payload.hospitalId;
//         } catch (_) {}
//       }
//     }
//     return null;
//   } catch {
//     return null;
//   }
// }

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const hId = getHospitalId();
//     if (!hId) {
//       showNotify("Error", "Not logged in. Please login first.", true);
//       return;
//     }
//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }
//     setPaying(true);
//     try {
//       const res = await fetch(`${BASE}/razorpay/create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
//       });
//       const order = await res.json();
//       if (!res.ok) throw new Error(order.message);

//       const options = {
//         key: order.keyId,
//         amount: order.amount,
//         currency: order.currency,
//         name: "PranJeev",
//         description: order.planLabel,
//         order_id: order.orderId,
//         prefill: { name: order.hospitalName, email: order.hospitalEmail || "" },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           try {
//             const verifyRes = await fetch(`${BASE}/razorpay/verify-payment`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//                 hospitalId: hId,
//                 plan: plan.id,
//               }),
//             });
//             const data = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(data.message);
//             showNotify(
//               "✅ Payment Successful!",
//               `Your ${plan.name} plan is now active! Confirmation email sent.`,
//             );
//             const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//             setStatus(await s.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };
//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setPaying(false);
//   };

//   if (!hospitalId)
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your PranJeev subscription plan.
//       </div>

//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 marginBottom: 8,
//                 flexWrap: "wrap",
//               }}
//             >
//               <span style={{ fontSize: 18 }}>
//                 {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//               </span>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//                 {status.isActive
//                   ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
//                   : status.daysLeft > 0
//                     ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                     : "Trial Expired"}
//               </div>
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Renews" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period}
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor:
//                   paying || (status?.isActive && status?.plan === plan.id)
//                     ? "not-allowed"
//                     : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>
//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · EMI available · GST applicable
//       </div>
//     </div>
//   );
// }

///////////// real razorpay

// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Rebranded: PranJeev → PranJeev
// // ✅ UPDATED: Real Razorpay Subscription API (auto-renewal)
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// function getHospitalId() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     if (slug) {
//       const token = localStorage.getItem(`pearlsmile_token_${slug}`);
//       if (token) {
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         try {
//           const token = localStorage.getItem(key);
//           const payload = JSON.parse(atob(token.split(".")[1]));
//           if (payload?.hospitalId) return payload.hospitalId;
//         } catch (_) {}
//       }
//     }
//     return null;
//   } catch {
//     return null;
//   }
// }

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const hId = getHospitalId();
//     if (!hId) {
//       showNotify("Error", "Not logged in. Please login first.", true);
//       return;
//     }
//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }
//     setPaying(true);
//     try {
//       // ✅ Step 1 — Create real Razorpay Subscription
//       const res = await fetch(`${BASE}/razorpay/create-subscription`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);

//       // ✅ Step 2 — Open Razorpay Subscription Checkout
//       const options = {
//         key: data.keyId,
//         subscription_id: data.subscriptionId, // ✅ subscription_id not order_id
//         name: "PranJeev",
//         description: data.planLabel,
//         prefill: {
//           name: data.hospitalName,
//           email: data.hospitalEmail || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           // ✅ Step 3 — Verify subscription payment
//           try {
//             const verifyRes = await fetch(
//               `${BASE}/razorpay/verify-subscription`,
//               {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   razorpay_payment_id: response.razorpay_payment_id,
//                   razorpay_subscription_id: response.razorpay_subscription_id,
//                   razorpay_signature: response.razorpay_signature,
//                   hospitalId: hId,
//                   plan: plan.id,
//                 }),
//               },
//             );
//             const verifyData = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(verifyData.message);
//             showNotify(
//               "✅ Subscription Active!",
//               `Your ${plan.name} plan is now active and will auto-renew monthly! Confirmation email sent.`,
//             );
//             const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//             setStatus(await s.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };
//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setPaying(false);
//   };

//   if (!hospitalId)
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your PranJeev subscription plan.
//       </div>

//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 marginBottom: 8,
//                 flexWrap: "wrap",
//               }}
//             >
//               <span style={{ fontSize: 18 }}>
//                 {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//               </span>
//               <div style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}>
//                 {status.isActive
//                   ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
//                   : status.daysLeft > 0
//                     ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                     : "Trial Expired"}
//               </div>
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Next billing" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {status.subscriptionId && (
//               <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
//                 Subscription ID: {status.subscriptionId}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period} · auto-renews
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor:
//                   paying || (status?.isActive && status?.plan === plan.id)
//                     ? "not-allowed"
//                     : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>
//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · Auto-renews monthly · Cancel anytime
//       </div>
//     </div>
//   );
// }

/// ato payment cancel

// // ============================================================
// // src/components/admin/SubscriptionPayment.js
// // ✅ Rebranded: PranJeev → PranJeev
// // ✅ UPDATED: Real Razorpay Subscription API (auto-renewal)
// // ✅ NEW: Cancel Subscription button
// // ============================================================
// import React, { useState, useEffect } from "react";

// const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) return resolve(true);
//     const s = document.createElement("script");
//     s.id = "razorpay-sdk";
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });
// }

// const PLANS = [
//   {
//     id: "starter",
//     name: "Starter",
//     price: "₹999",
//     period: "/month",
//     amount: 99900,
//     color: "#0d7377",
//     features: [
//       "3 Doctors",
//       "Appointments",
//       "Patient Records",
//       "Basic Billing",
//       "WhatsApp Notify",
//     ],
//   },
//   {
//     id: "pro",
//     name: "Pro",
//     price: "₹1,999",
//     period: "/month",
//     amount: 199900,
//     color: "#c9a845",
//     featured: true,
//     features: [
//       "10 Doctors",
//       "Everything in Starter",
//       "Advanced Billing",
//       "Invoice PDF",
//       "Priority Support",
//     ],
//   },
//   {
//     id: "enterprise",
//     name: "Enterprise",
//     price: "₹3,499",
//     period: "/month",
//     amount: 349900,
//     color: "#1a3a6b",
//     features: [
//       "Unlimited Doctors",
//       "Everything in Pro",
//       "Custom Domain",
//       "Dedicated Support",
//       "SLA Guarantee",
//     ],
//   },
// ];

// function getHospitalId() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     if (slug) {
//       const token = localStorage.getItem(`pearlsmile_token_${slug}`);
//       if (token) {
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         try {
//           const token = localStorage.getItem(key);
//           const payload = JSON.parse(atob(token.split(".")[1]));
//           if (payload?.hospitalId) return payload.hospitalId;
//         } catch (_) {}
//       }
//     }
//     return null;
//   } catch {
//     return null;
//   }
// }

// export default function SubscriptionPayment({ showNotify }) {
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(false);
//   const [cancelling, setCancelling] = useState(false); // ✅ NEW

//   const hospitalId = getHospitalId();

//   useEffect(() => {
//     if (!hospitalId) return;
//     setLoading(true);
//     fetch(`${BASE}/razorpay/status/${hospitalId}`)
//       .then((r) => r.json())
//       .then((data) => setStatus(data))
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [hospitalId]);

//   const handlePay = async (plan) => {
//     const hId = getHospitalId();
//     if (!hId) {
//       showNotify("Error", "Not logged in. Please login first.", true);
//       return;
//     }
//     const loaded = await loadRazorpayScript();
//     if (!loaded) {
//       showNotify("Error", "Failed to load payment gateway.", true);
//       return;
//     }
//     setPaying(true);
//     try {
//       // ✅ Step 1 — Create real Razorpay Subscription
//       const res = await fetch(`${BASE}/razorpay/create-subscription`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);

//       // ✅ Step 2 — Open Razorpay Subscription Checkout
//       const options = {
//         key: data.keyId,
//         subscription_id: data.subscriptionId,
//         name: "PranJeev",
//         description: data.planLabel,
//         prefill: {
//           name: data.hospitalName,
//           email: data.hospitalEmail || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           // ✅ Step 3 — Verify subscription payment
//           try {
//             const verifyRes = await fetch(
//               `${BASE}/razorpay/verify-subscription`,
//               {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   razorpay_payment_id: response.razorpay_payment_id,
//                   razorpay_subscription_id: response.razorpay_subscription_id,
//                   razorpay_signature: response.razorpay_signature,
//                   hospitalId: hId,
//                   plan: plan.id,
//                 }),
//               },
//             );
//             const verifyData = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(verifyData.message);
//             showNotify(
//               "✅ Subscription Active!",
//               `Your ${plan.name} plan is now active and will auto-renew monthly! Confirmation email sent.`,
//             );
//             const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//             setStatus(await s.json());
//           } catch (err) {
//             showNotify("Payment Error", err.message, true);
//           }
//         },
//         modal: { ondismiss: () => setPaying(false) },
//       };
//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setPaying(false);
//   };

//   // ✅ NEW — Cancel Subscription
//   const handleCancel = async () => {
//     if (
//       !window.confirm(
//         "Are you sure you want to cancel your subscription?\n\nYour plan will remain active until the current billing period ends, then auto-renewal will stop.",
//       )
//     )
//       return;
//     const hId = getHospitalId();
//     if (!hId) return;
//     setCancelling(true);
//     try {
//       const res = await fetch(`${BASE}/razorpay/cancel-subscription`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ hospitalId: hId }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message);
//       showNotify(
//         "Subscription Cancelled",
//         "Your subscription has been cancelled. Access continues until the current billing period ends.",
//       );
//       // Refresh status
//       const s = await fetch(`${BASE}/razorpay/status/${hId}`);
//       setStatus(await s.json());
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setCancelling(false);
//   };

//   if (!hospitalId)
//     return (
//       <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
//         <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
//         <div>Please login to view subscription details.</div>
//       </div>
//     );

//   return (
//     <div>
//       <div className="admin-section-title">Subscription & Billing</div>
//       <div className="admin-section-desc">
//         Manage your PranJeev subscription plan.
//       </div>

//       {loading ? (
//         <div style={{ padding: 20, color: "#94a3b8" }}>
//           Loading subscription status...
//         </div>
//       ) : (
//         status && (
//           <div
//             style={{
//               background: status.isActive
//                 ? "#f0fdf4"
//                 : status.daysLeft < 3
//                   ? "#fef2f2"
//                   : "#fff8e1",
//               border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
//               borderRadius: 12,
//               padding: "16px 20px",
//               marginBottom: 24,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 flexWrap: "wrap",
//                 gap: 10,
//                 marginBottom: 8,
//               }}
//             >
//               <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                 <span style={{ fontSize: 18 }}>
//                   {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
//                 </span>
//                 <div
//                   style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}
//                 >
//                   {status.isActive
//                     ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
//                     : status.daysLeft > 0
//                       ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
//                       : "Trial Expired"}
//                 </div>
//               </div>
//               {/* ✅ NEW — Cancel button shown only when active */}
//               {status.isActive && status.subscriptionId && (
//                 <button
//                   onClick={handleCancel}
//                   disabled={cancelling}
//                   style={{
//                     padding: "6px 14px",
//                     background: "none",
//                     border: "1.5px solid #fca5a5",
//                     borderRadius: 8,
//                     color: "#dc2626",
//                     fontSize: 12,
//                     fontWeight: 600,
//                     cursor: cancelling ? "not-allowed" : "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {cancelling ? "Cancelling..." : "🚫 Cancel Auto-Renewal"}
//                 </button>
//               )}
//             </div>
//             {status.expiry && (
//               <div style={{ fontSize: 13, color: "#64748b" }}>
//                 {status.isActive ? "Next billing" : "Expires"} on{" "}
//                 {new Date(status.expiry).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {status.subscriptionId && (
//               <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
//                 Subscription ID: {status.subscriptionId}
//               </div>
//             )}
//             {!status.isActive && status.daysLeft < 5 && (
//               <div
//                 style={{
//                   marginTop: 10,
//                   fontSize: 13,
//                   color: "#dc2626",
//                   fontWeight: 600,
//                 }}
//               >
//                 ⚠️ Subscribe now to avoid losing access to your admin panel!
//               </div>
//             )}
//           </div>
//         )
//       )}

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
//           gap: 16,
//           marginBottom: 20,
//         }}
//       >
//         {PLANS.map((plan) => (
//           <div
//             key={plan.id}
//             style={{
//               border: plan.featured
//                 ? `2px solid ${plan.color}`
//                 : "1.5px solid #e2e8f0",
//               borderRadius: 16,
//               padding: "20px 18px",
//               background: plan.featured ? "#fffdf0" : "#fff",
//               position: "relative",
//               boxShadow: plan.featured
//                 ? "0 4px 20px rgba(201,168,76,0.15)"
//                 : "0 2px 8px rgba(0,0,0,0.04)",
//             }}
//           >
//             {plan.featured && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: -12,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                   background: plan.color,
//                   color: "#fff",
//                   fontSize: 11,
//                   fontWeight: 700,
//                   padding: "3px 14px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Most Popular
//               </div>
//             )}
//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 15,
//                 color: "#0a1628",
//                 marginBottom: 4,
//               }}
//             >
//               {plan.name}
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 28,
//                 fontWeight: 700,
//                 color: plan.color,
//                 lineHeight: 1,
//               }}
//             >
//               {plan.price}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
//               {plan.period} · auto-renews
//             </div>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: "0 0 16px",
//                 fontSize: 13,
//                 color: "#475569",
//               }}
//             >
//               {plan.features.map((f) => (
//                 <li key={f} style={{ marginBottom: 6 }}>
//                   ✓ {f}
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => handlePay(plan)}
//               disabled={
//                 paying || (status?.isActive && status?.plan === plan.id)
//               }
//               style={{
//                 width: "100%",
//                 padding: "11px",
//                 background:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#e2e8f0"
//                     : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 color:
//                   status?.isActive && status?.plan === plan.id
//                     ? "#94a3b8"
//                     : "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor:
//                   paying || (status?.isActive && status?.plan === plan.id)
//                     ? "not-allowed"
//                     : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {status?.isActive && status?.plan === plan.id
//                 ? "✅ Current Plan"
//                 : paying
//                   ? "Processing..."
//                   : `Subscribe — ${plan.price}/mo`}
//             </button>
//           </div>
//         ))}
//       </div>
//       <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
//         🔒 Secure payment via Razorpay · Auto-renews monthly · Cancel anytime
//       </div>
//     </div>
//   );
// }

//////// final cancellation set
// ============================================================
// src/components/admin/SubscriptionPayment.js
// ✅ Rebranded: PranJeev → PranJeev
// ✅ UPDATED: Real Razorpay Subscription API (auto-renewal)
// ✅ NEW: Cancel Subscription button
// ============================================================
import React, { useState, useEffect } from "react";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (document.getElementById("razorpay-sdk")) return resolve(true);
    const s = document.createElement("script");
    s.id = "razorpay-sdk";
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

const PLANS = [
  {
    id: "starter",
    name: "Starter",
    price: "₹999",
    period: "/month",
    amount: 99900,
    color: "#0d7377",
    features: [
      "3 Doctors",
      "Appointments",
      "Patient Records",
      "Basic Billing",
      "WhatsApp Notify",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "₹1,999",
    period: "/month",
    amount: 199900,
    color: "#c9a845",
    featured: true,
    features: [
      "10 Doctors",
      "Everything in Starter",
      "Advanced Billing",
      "Invoice PDF",
      "Priority Support",
    ],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "₹3,499",
    period: "/month",
    amount: 349900,
    color: "#1a3a6b",
    features: [
      "Unlimited Doctors",
      "Everything in Pro",
      "Custom Domain",
      "Dedicated Support",
      "SLA Guarantee",
    ],
  },
];

function getHospitalId() {
  try {
    const path = window.location.pathname;
    const match = path.match(/\/hospital\/([^/]+)/);
    const slug = match ? match[1] : null;
    if (slug) {
      const token = localStorage.getItem(`pearlsmile_token_${slug}`);
      if (token) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload?.hospitalId) return payload.hospitalId;
      }
    }
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("pearlsmile_token_")) {
        try {
          const token = localStorage.getItem(key);
          const payload = JSON.parse(atob(token.split(".")[1]));
          if (payload?.hospitalId) return payload.hospitalId;
        } catch (_) {}
      }
    }
    return null;
  } catch {
    return null;
  }
}

export default function SubscriptionPayment({ showNotify }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paying, setPaying] = useState(false);
  const [cancelling, setCancelling] = useState(false); // ✅ NEW

  const hospitalId = getHospitalId();

  useEffect(() => {
    if (!hospitalId) return;
    setLoading(true);
    fetch(`${BASE}/razorpay/status/${hospitalId}`)
      .then((r) => r.json())
      .then((data) => setStatus(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [hospitalId]);

  const handlePay = async (plan) => {
    const hId = getHospitalId();
    if (!hId) {
      showNotify("Error", "Not logged in. Please login first.", true);
      return;
    }
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      showNotify("Error", "Failed to load payment gateway.", true);
      return;
    }
    setPaying(true);
    try {
      // ✅ Step 1 — Create real Razorpay Subscription
      const res = await fetch(`${BASE}/razorpay/create-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hospitalId: hId, plan: plan.id }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      // ✅ Store subscription ID so we can cancel if user dismisses
      const newSubId = data.subscriptionId;

      // ✅ Step 2 — Open Razorpay Subscription Checkout
      const options = {
        key: data.keyId,
        subscription_id: newSubId,
        name: "PranJeev",
        description: data.planLabel,
        prefill: {
          name: data.hospitalName,
          email: data.hospitalEmail || "",
        },
        theme: { color: "#0d7377" },
        handler: async (response) => {
          // ✅ Step 3 — Verify subscription payment
          try {
            const verifyRes = await fetch(
              `${BASE}/razorpay/verify-subscription`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_subscription_id: response.razorpay_subscription_id,
                  razorpay_signature: response.razorpay_signature,
                  hospitalId: hId,
                  plan: plan.id,
                }),
              },
            );
            const verifyData = await verifyRes.json();
            if (!verifyRes.ok) throw new Error(verifyData.message);
            showNotify(
              "✅ Subscription Active!",
              `Your ${plan.name} plan is now active and will auto-renew monthly! Confirmation email sent.`,
            );
            const s = await fetch(`${BASE}/razorpay/status/${hId}`);
            setStatus(await s.json());
          } catch (err) {
            showNotify("Payment Error", err.message, true);
          }
        },
        modal: {
          ondismiss: async () => {
            // ✅ FIX: Cancel pending subscription when user dismisses without paying
            setPaying(false);
            try {
              await fetch(`${BASE}/razorpay/cancel-pending`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  subscriptionId: newSubId,
                  hospitalId: hId,
                }),
              });
              console.log("Pending subscription cancelled on dismiss");
            } catch (_) {}
            // Refresh status to restore original state
            try {
              const s = await fetch(`${BASE}/razorpay/status/${hId}`);
              setStatus(await s.json());
            } catch (_) {}
          },
        },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setPaying(false);
  };

  // ✅ NEW — Cancel Subscription
  const handleCancel = async () => {
    if (
      !window.confirm(
        "Are you sure you want to cancel your subscription?\n\nYour plan will remain active until the current billing period ends, then auto-renewal will stop.",
      )
    )
      return;
    const hId = getHospitalId();
    if (!hId) return;
    setCancelling(true);
    try {
      const res = await fetch(`${BASE}/razorpay/cancel-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hospitalId: hId }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      showNotify(
        "Subscription Cancelled",
        "Your subscription has been cancelled. Access continues until the current billing period ends.",
      );
      // Refresh status
      const s = await fetch(`${BASE}/razorpay/status/${hId}`);
      setStatus(await s.json());
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setCancelling(false);
  };

  if (!hospitalId)
    return (
      <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
        <div>Please login to view subscription details.</div>
      </div>
    );

  return (
    <div>
      <div className="admin-section-title">Subscription & Billing</div>
      <div className="admin-section-desc">
        Manage your PranJeev subscription plan.
      </div>

      {loading ? (
        <div style={{ padding: 20, color: "#94a3b8" }}>
          Loading subscription status...
        </div>
      ) : (
        status && (
          <div
            style={{
              background: status.isActive
                ? "#f0fdf4"
                : status.daysLeft < 3
                  ? "#fef2f2"
                  : "#fff8e1",
              border: `1px solid ${status.isActive ? "#bbf7d0" : status.daysLeft < 3 ? "#fecaca" : "#fde68a"}`,
              borderRadius: 12,
              padding: "16px 20px",
              marginBottom: 24,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 10,
                marginBottom: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 18 }}>
                  {status.isActive ? "✅" : status.daysLeft < 3 ? "⚠️" : "⏳"}
                </span>
                <div
                  style={{ fontWeight: 700, fontSize: 15, color: "#0a1628" }}
                >
                  {status.isActive
                    ? `${status.plan?.charAt(0).toUpperCase() + status.plan?.slice(1)} Plan — Active`
                    : status.daysLeft > 0
                      ? `Trial — ${status.daysLeft} day${status.daysLeft !== 1 ? "s" : ""} left`
                      : "Trial Expired"}
                </div>
              </div>
              {/* ✅ NEW — Cancel button shown only when active */}
              {status.isActive && status.subscriptionId && (
                <button
                  onClick={handleCancel}
                  disabled={cancelling}
                  style={{
                    padding: "6px 14px",
                    background: "none",
                    border: "1.5px solid #fca5a5",
                    borderRadius: 8,
                    color: "#dc2626",
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: cancelling ? "not-allowed" : "pointer",
                    fontFamily: "DM Sans,sans-serif",
                    whiteSpace: "nowrap",
                  }}
                >
                  {cancelling ? "Cancelling..." : "🚫 Cancel Auto-Renewal"}
                </button>
              )}
            </div>
            {status.expiry && (
              <div style={{ fontSize: 13, color: "#64748b" }}>
                {status.isActive ? "Next billing" : "Expires"} on{" "}
                {new Date(status.expiry).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </div>
            )}
            {status.subscriptionId && (
              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                Subscription ID: {status.subscriptionId}
              </div>
            )}
            {!status.isActive && status.daysLeft < 5 && (
              <div
                style={{
                  marginTop: 10,
                  fontSize: 13,
                  color: "#dc2626",
                  fontWeight: 600,
                }}
              >
                ⚠️ Subscribe now to avoid losing access to your admin panel!
              </div>
            )}
          </div>
        )
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
          gap: 16,
          marginBottom: 20,
        }}
      >
        {PLANS.map((plan) => (
          <div
            key={plan.id}
            style={{
              border: plan.featured
                ? `2px solid ${plan.color}`
                : "1.5px solid #e2e8f0",
              borderRadius: 16,
              padding: "20px 18px",
              background: plan.featured ? "#fffdf0" : "#fff",
              position: "relative",
              boxShadow: plan.featured
                ? "0 4px 20px rgba(201,168,76,0.15)"
                : "0 2px 8px rgba(0,0,0,0.04)",
            }}
          >
            {plan.featured && (
              <div
                style={{
                  position: "absolute",
                  top: -12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: plan.color,
                  color: "#fff",
                  fontSize: 11,
                  fontWeight: 700,
                  padding: "3px 14px",
                  borderRadius: 20,
                }}
              >
                Most Popular
              </div>
            )}
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                color: "#0a1628",
                marginBottom: 4,
              }}
            >
              {plan.name}
            </div>
            <div
              style={{
                fontFamily: "Cormorant Garamond,serif",
                fontSize: 28,
                fontWeight: 700,
                color: plan.color,
                lineHeight: 1,
              }}
            >
              {plan.price}
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 14 }}>
              {plan.period} · auto-renews
            </div>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: "0 0 16px",
                fontSize: 13,
                color: "#475569",
              }}
            >
              {plan.features.map((f) => (
                <li key={f} style={{ marginBottom: 6 }}>
                  ✓ {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => handlePay(plan)}
              disabled={
                paying || (status?.isActive && status?.plan === plan.id)
              }
              style={{
                width: "100%",
                padding: "11px",
                background:
                  status?.isActive && status?.plan === plan.id
                    ? "#e2e8f0"
                    : "linear-gradient(135deg,#0d7377,#14a0a5)",
                color:
                  status?.isActive && status?.plan === plan.id
                    ? "#94a3b8"
                    : "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 700,
                cursor:
                  paying || (status?.isActive && status?.plan === plan.id)
                    ? "not-allowed"
                    : "pointer",
                fontFamily: "DM Sans,sans-serif",
              }}
            >
              {status?.isActive && status?.plan === plan.id
                ? "✅ Current Plan"
                : paying
                  ? "Processing..."
                  : `Subscribe — ${plan.price}/mo`}
            </button>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
        🔒 Secure payment via Razorpay · Auto-renews monthly · Cancel anytime
      </div>
    </div>
  );
}
